const ENTITIES_STRUCT = {
  ADMIN: "person",
  AGENT: "agent",
  ME: "me",
  ROLE: "role",
  QUESTIONS: "question",
  TESTS: "test",
  TESTS_RESULTS: "testresult",
  CATEGORIES: "category",
  LINES: "line",
  DIRECTIONS: "direction",
};

export default ENTITIES_STRUCT;

export const initialState = () => ({
  [ENTITIES_STRUCT.ADMIN]: [],
  [ENTITIES_STRUCT.AGENT]: [],
  [ENTITIES_STRUCT.ROLE]: [],
  [ENTITIES_STRUCT.QUESTIONS]: [],
  [ENTITIES_STRUCT.TESTS]: [],
  [ENTITIES_STRUCT.TESTS_RESULTS]: [],
  [ENTITIES_STRUCT.CATEGORIES]: [],
  [ENTITIES_STRUCT.LINES]: [],
  [ENTITIES_STRUCT.DIRECTIONS]: [],
});
